module.exports = __webpack_public_path__ + "static/media/Snow Guardian.3f465af5.jpg";